import React from 'react';
import { useAgile } from '@agile-ts/react';
import { relibirds, ui } from '../../../../../core';
import { useWindowSize } from '../../../../hooks/useWindowSize';
import { DEFAULT_CANVAS_DIMENSIONS } from '../../../../../core/entities/relibirds';

export function useGame() {
  const [backgroundWrapper, foregroundWrapper, bird, pipeSets, status] =
    useAgile([
      relibirds.BACKGROUND_WRAPPER,
      relibirds.FOREGROUND_WRAPPER,
      relibirds.BIRD,
      relibirds.PIPE_SETS,
      relibirds.STATUS,
    ]);
  const { windowWidth } = useWindowSize();

  // Update Canvas dimensions
  React.useEffect(() => {
    if (
      windowWidth == null ||
      windowWidth >= relibirds.DEFAULT_CANVAS_DIMENSIONS.width
    ) {
      relibirds.GAME.canvasDimensions = DEFAULT_CANVAS_DIMENSIONS;
    } else {
      relibirds.GAME.canvasDimensions = {
        width: windowWidth * (ui.INNER_WIDTH / 100),
        height: relibirds.DEFAULT_CANVAS_DIMENSIONS.height,
      };
    }
  }, [windowWidth]);

  React.useEffect(() => {
    relibirds.FPS_CONTROLLER.startDrawing(
      relibirds.updateFrame,
      relibirds.renderFrame,
    );
    return relibirds.FPS_CONTROLLER.stopDrawing;
  }, []);

  return {
    backgrounds: backgroundWrapper.backgrounds,
    foregrounds: foregroundWrapper.foregrounds,
    bird,
    pipeSets,
    status,
  };
}
